export var PersonalTaxIdFormatterFactory = (function() {
    /* Public Functions */

    var getTaxIdFormatter = function(countryCode) {
        switch (countryCode) {
        case 'AR': {
            return commonFormatter();
        }
        case 'RU': {
            return commonFormatter();
        }
        case 'CL': {
            return clFormatter();
        }
        case 'CA': {
            return caFormatter('***-***-');
        }
        case 'US': {
            return usFormatter('***-**-');
        }
        case 'MY': {
            return myFormatter();
        }
        case 'PH': {
            return phFormatter('***-***-');
        }
        case 'TH': {
            return thFormatter('**********');
        }
        case 'ES': {
            return esFormatter();
        }
        case 'HK': {
            return hkFormatter();
        }
        case 'FR': {
            return frFormatter();
        }
        case 'ZA': {
            return commonFormatter('**********');
        }
        case 'ID': {
            return commonFormatter('**.***.***.*-***.');
        }
        case 'IT': {
            return commonFormatter('*************');
        }
        case 'MX': {
            return commonFormatter('***************');
        }
        case 'VN': {
            return commonFormatter();
        }
        case 'UA': {
            return commonFormatter('HE***');
        }
        case 'IL': {
            return commonFormatter('******');
        }
        case 'CZ': {
            return commonFormatter();
        }
        case 'HU': {
            return commonFormatter();
        }
        case 'NL': {
            return commonFormatter();
        }
        case 'PF': {
            return commonFormatter();
        }
        case 'PL': {
            return commonFormatter();
        }
        case 'RO': {
            return commonFormatter();
        }
        case 'SK': {
            return commonFormatter();
        }
        case 'CO': {
            return commonFormatter();
        }
        case 'SG': {
            return commonFormatter();
        }
        case 'BN': {
            return commonFormatter('**-***');
        }
        // Those with No personal TaxId.
        default: {
            return defaultFormatter();
        }
        }
    };

    var commonFormatter = function(taxIdMask) {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value.toUpperCase() : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            if (taxIdMask) {
                return taxIdValue ? taxIdMask + taxIdValue.substr(-3) : '';
            } else {
                return taxIdValue ? '*'.repeat(taxIdValue.length - 3) + taxIdValue.substr(-3) : '';
            }
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId
        };
    };

    var clFormatter = function() {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value.substr(0, 2) + '.' + taxId.value.substr(2, 3)
                        + '.' + taxId.value.substr(5, 3) + '.' + taxId.value.substr(8, 1) : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            if (/\-/.test(taxIdValue)) {
                return taxIdValue ? '**.***.*' + taxIdValue.substr(-4) : '';
            } else {
                return taxIdValue ? '**.***.*' + taxIdValue.substr(-3, 2) + '-' + taxIdValue.substr(-1) : '';
            }
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId,
        };
    };

    var usFormatter = function(taxIdMask) {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value.substr(0, 3) + '-' + taxId.value.substr(3, 2)
                        + '-' + taxId.value.substr(5, 4) : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            return taxIdValue ? taxIdMask + taxIdValue.substr(-4) : '';
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId,
        };
    };

    var caFormatter = function(taxIdMask) {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value.substr(0, 3) + '-' + taxId.value.substr(3, 3)
                        + '-' + taxId.value.substr(6, 3) : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            return taxIdValue ? taxIdMask + taxIdValue.substr(-3) : '';
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId,
        };
    };

    var myFormatter = function() {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value.substr(0, 6) + '-' + taxId.value.substr(6, 2)
                        + '-' + taxId.value.substr(8, 4) : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            return taxIdValue ? '******-**-' + taxIdValue.substr(-4) : '';
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId,
        };
    };

    var phFormatter = function(taxIdMask) {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            return taxIdValue ? taxIdMask + taxIdValue.substr(-3) : '';
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId,
        };
    };

    var thFormatter = function() {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            return taxIdValue ? '*'.repeat(taxIdValue.length - 3) + taxIdValue.substr(-3) : '';
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId,
        };
    };

    var esFormatter = function() {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value.toUpperCase() : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            if (/\-/.test(taxIdValue)) {
                return taxIdValue ? '*-*****' + taxIdValue.substr(-4) : '';
            } else {
                return taxIdValue ? '*-*****' + taxIdValue.substr(-3, 2) + '-' + taxIdValue.substr(-1) : '';
            }
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId,
        };
    };

    var hkFormatter = function() {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value.toUpperCase() : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            return taxIdValue ? '*****' + taxIdValue.substr(taxIdValue.length - 3) : '';
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId,
        };
    };

    var frFormatter = function() {
        var formatToService = function(taxId) {
            return {
                legalIDs: [{
                    'type': taxId.type,
                    'value': taxId.value ? taxId.value : undefined,
                    'action': 'ADD'
                }]
            };
        };
        var formatFromService = function(legalIDs) {
            return legalIDs.slice(0, 2);
        };
        var maskTaxId = function(taxIdValue) {
            if (/\s/.test(taxIdValue)) {
                return taxIdValue ? '************' + taxIdValue.substr(-4) : '';
            } else {
                return taxIdValue ? '************' + taxIdValue.substr(-3, 1) + ' ' + taxIdValue.substr(-2) : '';
            }
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId,
        };
    };

    var defaultFormatter = function() {
        var formatToService = function(taxId) {
            return null;
        };
        var formatFromService = function(legalIDs) {
            return null;
        };
        var maskTaxId = function(taxIdValue) {
            return null;
        };
        return {
            formatToService: formatToService,
            formatFromService: formatFromService,
            maskTaxId: maskTaxId
        };
    };

    return {
        getTaxIdFormatter: getTaxIdFormatter
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/tax-id/personal-tax-id-formatter.js
// module id = 344
// module chunks = 0